import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { config } from '../../shared/config';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AcceptParsedData } from '../interfaces/accept-parsed-data';
import { PaginationWrapper } from '../../shared/models/pagination-wrapper';
import { FuelCard } from '../models/fuel-card';
import { FuelingMerge } from '../models/fueling-merge';
import { FuelingMergeBase } from '../models/fueling-merge-base';
import { UpdateFuelingResponse } from '../interfaces/update-fueling-response';
import {FileMetaData} from '../models/file-meta-data';
import { SaveParsedDataResponse } from '../models/save-parsed-data-response';
import { BaseHttpService } from '../../core/services/base-http.service';
import { StorageService } from '../../core/storage/storage.service';

@Injectable({
  providedIn: 'root'
})
export class FuelCardService extends BaseHttpService {

  constructor(
    protected _http: HttpClient,
    protected _storage: StorageService,
  ) {
    super(_http, _storage);
  }

  parseFuelCard(form): Observable<any> {

    return this._http.post(config.generateApiUrl('FuelCard/File', null, null, '2.0'), form)
      .pipe(map(resp => resp['data']));
  }

  saveParsedFuelCard(data: AcceptParsedData): Observable<SaveParsedDataResponse> {
    return this._http.post(config.generateApiUrl('FuelCard', null, null, '2.0'), data)
      .pipe(map(resp => resp['data']));
  }

  getFuelCards(currentPage = 1, pageSize = 10): Observable<PaginationWrapper<FuelCard>> {
    const fields = ['*'];
    return this.get(config.generateApiUrl('FuelCard', fields, null, '2.0') + `&page=${currentPage}&pageSize=${pageSize}`)
      .pipe(map(resp => resp['data']));
  }

  getFilesMetaData(): Observable<FileMetaData[]> {
    return this.get(config.generateApiUrl('FuelCard/FilesMetadata', null, null, '2.0'))
      .pipe(map(resp => resp['data']['items']));
  }

  premerge(data): Observable<any[]> {
    return this._http.post(config.generateApiUrl('FuelingMerge/Premerge', null, null, '2.0'), data)
      .pipe(map(resp => resp['data']));
  }

  getFuelingMerge(unitIds: number[], from, to): Observable<FuelingMerge[]> {
    const fields = ['*'];
    return this.get(config.generateApiUrl('FuelingMerge', fields, null, '2.0') + `&unitIds=${unitIds.join(',')}&from=${from}&to=${to}`)
      .pipe(map(resp => resp['data']));
  }

  updateFuelingMerge(fuelingMergeId, data: FuelingMergeBase): Observable<UpdateFuelingResponse> {
    return this._http.put(config.generateApiUrl('FuelingMerge/' + fuelingMergeId, null, null, '2.0'), data)
      .pipe(map(resp => resp['data']));
  }

  unMergeFuelingMerge(fuelingMergeId, data: FuelingMergeBase): Observable<number[]> {
    return this._http.post<number[]>(config.generateApiUrl('FuelingMerge/Unmerge/' + fuelingMergeId, null, null, '2.0'), data)
      .pipe(map(resp => resp['data']));
  }

  addFuelingMerge(data: FuelingMerge): Observable<UpdateFuelingResponse> {
    return this._http.post(config.generateApiUrl('FuelingMerge', null, null, '2.0'), data)
      .pipe(map(resp => resp['data']));
  }

  getFuelingMergeById(id: number): Observable<FuelingMerge> {
    const fields = ['*'];
    return this.get(config.generateApiUrl('FuelingMerge/' + id, fields, null, '2.0'))
      .pipe(map(resp => resp['data']));
  }

  deleteFuelingMergeById(id: number): Observable<any> {
    return this._http.delete(config.generateApiUrl('FuelingMerge/' + id, null, null, '2.0'));
  }

  approveFuelingMerge(fuelingMergeId): Observable<any> {
    return this._http.put(config.generateApiUrl('FuelingMerge/Approve/' + fuelingMergeId, null, null, '2.0'), null)
      .pipe(map(resp => resp['data']));
  }

  mergeFuelingMerge(data: FuelingMergeBase, id1, id2): Observable<UpdateFuelingResponse> {
    return this._http.patch(config.generateApiUrl(`FuelingMerge/Merge/${id1}/${id2}`, null, null, '2.0'), data)
      .pipe(map(resp => resp['data']));
  }
  markAsRealFueling(fuelingMergeId): Observable<any> {
    return this._http.put(config.generateApiUrl('FuelingMerge/MarkAsReal/' + fuelingMergeId, null, null, '2.0'), null)
      .pipe(map(resp => resp['data']));
  }
  markAsNotRealFueling(fuelingMergeId): Observable<any> {
    return this._http.put(config.generateApiUrl('FuelingMerge/MarkAsNotReal/' + fuelingMergeId, null, null, '2.0'), null)
      .pipe(map(resp => resp['data']));
  }
}
